<template>
    <v-card-text class="py-0">
        <v-container class="px-4">
            <v-row>
                <v-col v-if="utils.getPlatform() === $const.PLATFORM_TRADEBALL" cols="6" class="pl-0 pr-1 py-3">
                    <AppForm ref="setLocaleForm" @keyup.native.enter="setLocale">
                        <v-autocomplete
                            dense
                            outlined
                            flat
                            hide-details
                            small
                            ref="localeValue"
                            class="filter"
                            color="grey"
                            :label="$t('menu.language')"
                            :items="getLanguage"
                            :rules="rules.locale"
                            item-value="id"
                            item-text="name"
                            :value="this.$i18n.locale"
                            @change="(value) => setLocale(value)"
                        ></v-autocomplete>
                    </AppForm>
                </v-col>
                <v-col :cols="utils.getPlatform() === $const.PLATFORM_TRADEBALL ? 6 : 12" class="pl-1 pr-0 py-3">
                    <AppForm ref="setTimeZoneForm" @keyup.native.enter="setTimeZone">
                        <v-autocomplete
                            dense
                            outlined
                            flat
                            hide-details
                            small
                            ref="timeZoneValue"
                            class="filter"
                            color="grey"
                            :label="$t('menu.timeZone')"
                            :items="getTimeZone"
                            :rules="rules.timeZone"
                            item-value="code"
                            item-text="name"
                            :value="user.timeZone"
                            @change="(value) => setTimeZone(value)"
                        ></v-autocomplete>
                    </AppForm>
                </v-col>
            </v-row>
        </v-container>
    </v-card-text>
</template>
<style scoped></style>
<script>
    import AppForm from 'Pages/core/form/AppForm';
    import { mapGetters } from 'vuex';
    import store from '~/store';

    export default {
        name: 'app-menuAccountChangeLocaleAndTimeZone',
        components: {
            AppForm,
        },
        data() {
            return {
                rules: {
                    timeZone: [(v) => !!v || store.$i18n.t('rules.required')],
                    locale: [(v) => !!v || store.$i18n.t('rules.required')],
                },
            };
        },

        created: function () {
            console.log('Component %s was created.', this.$options.name);
        },

        mounted() {
            console.log('Component %s mounted.', this.$options.name);
        },

        methods: {
            setLocale(locale) {
                locale = locale.toLowerCase();
                if (this.$i18n.locale !== locale) {
                    this.$i18n.locale = locale;
                    localStorage.setItem('locale', locale);
                }
            },
            setTimeZone(value) {
                let validationResult = this.$refs.setTimeZoneForm.$refs.form.validate();

                if (validationResult) {
                    let params = {
                        timezone: value,
                    };

                    this.user.timeZone = value;

                    if (this.user.type === this.$const.USER_TYPE_PLAYER_ID) {
                        this.$store.dispatch('UserModule/setTimeZone', params).then((response) => {
                            if (response.data.success) {
                                localStorage.setItem('user', JSON.stringify(this.user));
                                // this.userMenu = false;
                            }
                        });
                    } else {
                        localStorage.setItem('user', JSON.stringify(this.user));
                    }
                }
            },
        },

        computed: {
            ...mapGetters({
                getTimeZone: 'DictionariesModule/getTimeZone',
                getLanguage: 'DictionariesModule/getLanguage',
            }),

            user() {
                return this.$store.getters['UserModule/getUser'];
            },
        },
    };
</script>
